<template>
  <div class="pageContainer">
    <div style="text-align: right">
      <el-button type="default" @click.stop="onBack">返回</el-button>
    </div>
    <div class="resultArea u-border">
      <el-form label-position="left" label-width="80px" :model="cloudForm">
        <el-form-item label="工厂名称">{{cloudForm.factory_name}}</el-form-item>
        <el-form-item label="企业类别">{{cloudForm.enterprise_type_label}}</el-form-item>
        <el-form-item label="生产品类">{{cloudForm.product_type_label}}</el-form-item>
        <el-form-item label="车间人数">{{cloudForm.work_num}}</el-form-item>
        <el-form-item label="产线数量">{{cloudForm.production_qty}}</el-form-item>
        <el-form-item label="产线人数">{{cloudForm.production_num}}</el-form-item>
        <el-form-item label="场地面积">{{cloudForm.site_area}} m²</el-form-item>
        <el-form-item label="合作模式">{{cloudForm.cooperation_type_label}}</el-form-item>
        <el-form-item label="合作品牌">{{cloudForm.cooperation_brand}}</el-form-item>
        <el-form-item label="联系人">{{cloudForm.contact_name}}</el-form-item>
        <el-form-item label="联系方式">{{cloudForm.contact_phone}}</el-form-item>
        <el-form-item label="详细地址">{{cloudForm.contact_address}}</el-form-item>
        <el-form-item label="营业执照">
          <img v-if="cloudForm.picture" :src="cloudForm.picture" class="avatar" style="width:300px" />
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getCloudFactoryDetail } from '@/api/apii';

export default {
  name: 'cloudfactorydetail',
  props: {},
  data () {
    return {
      cloudForm: {}
    };
  },
  methods: {
    getCloudFactoryDetail () {
      let id = this.$route.params.id;
      getCloudFactoryDetail(id)
        .then((res) => {
          this.cloudForm = res.data;
        })
        .catch(() => {
          this.myMessage.megError('获取详情信息失败');
        });
    },
    onBack () {
      this.$router.back();
    }
  },
  created () {
    this.getCloudFactoryDetail();
  }
};
</script>

<style lang="scss">
</style>
